<template>
	<v-card>
		<stepper ref="stepper"></stepper>
	</v-card>
</template>

<script>
import Stepper from "./components/Stepper";
import Prepare from "./components/zwave/Prepare";
import Pair from "./components/zwave/Pair";
import wizardBase from "./extends/wizard";

export default {
	components: { Stepper },

	mixins: [wizardBase],

	data: () => ({
		type: "zwave",
		defaultConfig: {
			steps: [
				{
					title: "Prepare for Pairing",
					text: "Locate the pairing button on the device",
					component: Prepare,
				},
				{
					title: "Pair the Device",
					text: "Click the pairing button on the device.",
					component: Pair,
				},
			],
		},
	}),
};
</script>
